// extracted by mini-css-extract-plugin
export default {"iconSuccess":"IconSuccess_iconSuccess__oOvAt"};